import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";
import { generateSkillFields } from "../helpers/generateSkillFields";

export const selectSkillsState = (state: RootState) => state.skillsState;

export const selectSkillValue = createSelector(
  selectSkillsState,
  (state) => state.skillValue,
);

export const selectSkillFields = createSelector(selectSkillValue, (state) => {
  if (!state?.skill_object) return [];
  return generateSkillFields(state.skill_object);
});
